<app-modal>
	<div modal-header>
		<span  i18n="Modal Titel for PreRegistration@preregister.modal.title">Interested?</span>
	</div>
	<div modal-body>
		<span i18n="Explaination for PreRegistration@preregister.modal.explain">If you want to be part of the up-coming Closed Beta enter your email address below!</span>
		<enlist-form></enlist-form>
	</div>
</app-modal>



